module.exports = __webpack_public_path__ + "img/安全监测.2239e8d4.png";